import { CampaignProspectType } from '../api/campaigns';
import type { CampaignSpreadsheetViewType } from '../context/CampaignContext';

/** Header bar background only (accounts / leads / opportunities). */
export type CampaignHeaderChromePalette = {
  campaignChromeAccountBg: string;
  campaignChromeLeadBg: string;
  campaignChromeOpportunityBg: string;
};

export function resolveCampaignHeaderBackground(
  c: CampaignHeaderChromePalette,
  prospectType: CampaignProspectType | undefined,
  viewType: CampaignSpreadsheetViewType
): string {
  if (prospectType !== CampaignProspectType.ACCOUNT) {
    return c.campaignChromeOpportunityBg;
  }
  return viewType === 'lead'
    ? c.campaignChromeLeadBg
    : c.campaignChromeAccountBg;
}
